/*
 * @Author: jiansuiwang@rastar.com
 * @Date: 2023-05-06 15:25:05
 * @LastEditors: jiansuiwang@rastar.com
 * @LastEditTime: 2023-05-06 16:03:26
 * @FilePath: \xhwebtool\src\utils\index.ts
 */
/**
 * 获取手机操作系统类型
 */
var getMobileOs = function () {
    var userAgent = navigator.userAgent;
    if (/android/i.test(userAgent)) {
        return "Android";
    }
    if (/iPad|iPhone|iPod/.test(userAgent)) {
        return "iOS";
    }
    return "unknown";
};
/**
 * 获取操作系统类型
 */
var getOs = function () {
    var platform = navigator.userAgent;
    if (/win/i.test(platform)) {
        return "Windows";
    }
    if (/mac/i.test(platform)) {
        return "Mac OS";
    }
    if (/linux/i.test(platform)) {
        return "Linux";
    }
    if (/iphone|ipad|ipod/i.test(platform)) {
        return "iOS";
    }
    if (/android/i.test(platform)) {
        return "Android";
    }
    if (/winphone/i.test(platform)) {
        return "Windows Phone";
    }
    return "unknown";
};
/**
 * 获取当前时区
 */
var getTimeZone = function () {
    var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timeZone;
};
/**
 * 获取当前时区
 * @returns 返回时间偏移
 */
var getTimeZoneNum = function () {
    return new Date().getTimezoneOffset() / 60;
};
/**
 * 判断是否微信浏览器
 */
var isWeixinBrowser = function () {
    var userAgent = navigator.userAgent;
    return /MicroMessenger/i.test(userAgent);
};
/**
 * 判断是否QQ浏览器
 */
var isQQBrowser = function () {
    var userAgent = navigator.userAgent;
    return /QQBrowser/i.test(userAgent);
};
/**
 * 获取url参数
 * @param {string} key url键名
 * @param {string} url 默认为当前url.search值
 * @return {string} 参数值
 */
var getUrlParams = function (key, url) {
    if (url === void 0) { url = window.location.search; }
    var params = new URLSearchParams(url);
    return params.get(key);
};
/**
 * 去除字符串中标签
 */
var stripHtmlTags = function (html) {
    var regex = /(<([^>]+)>)/gi;
    return html.replace(regex, "");
};
/**
 * 格式化时间戳
 * @param timestamp
 */
var formatDate = function (timestamp, format) {
    if (format === void 0) { format = "YYYY-MM-DD HH:mm:ss"; }
    if (timestamp.toString().length === 10) {
        timestamp = timestamp * 1000;
    }
    var date = new Date(timestamp);
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var hour = date.getHours();
    var minute = date.getMinutes();
    var second = date.getSeconds();
    var formatObj = {
        YYYY: year,
        MM: month < 10 ? "0".concat(month) : month,
        DD: day < 10 ? "0".concat(day) : day,
        HH: hour < 10 ? "0".concat(hour) : hour,
        mm: minute < 10 ? "0".concat(minute) : minute,
        ss: second < 10 ? "0".concat(second) : second,
    };
    var keys = Object.keys(formatObj);
    return keys.reduce(function (result, key) {
        return result.replace(key, String(formatObj[key]));
    }, format);
};

export { formatDate, getMobileOs, getOs, getTimeZone, getTimeZoneNum, getUrlParams, isQQBrowser, isWeixinBrowser, stripHtmlTags };
